export default "skymp5-front/a7812039f879813576e2882c9767f86c.png";